<template>
  <div class="orderpage container row">
    <div class="col-md-4 col-12 order_msg">
      <div  class="order_products d-block d-md-none" >
        <div class="order_product"  v-for="item in items" :key="item.order_item_id">
          <!-- 商品名 -->
          <div class="order_product__name">
            <span class="order_product__name__title">
              <i class="page_text_font">{{$t('account.product')}}</i>
            </span>
            <span class="page_text_font">
                <a class="page_text_font_msg" :href="item.path||item.public_url">{{item.order_item_name}}</a>
                <div class="page_text_font_msg">{{getProductVariant(item.attrs)}}</div>
            </span>
          </div>
          <!-- sku -->
          <div class="order_product__sku">
            <span class='text-uppercase'>
              <i class="page_text_font">{{$t('account.sku')}}</i>
            </span>
            <span class="page_text_font">
                <i class="page_text_font_msg">{{item.sku}}</i>
            </span>
          </div>
          <!-- 价格 -->
          <div class="order_product__price">
            <span>
              <i class="page_text_font">{{$t('account.price')}}</i>
            </span>
            <span  class="page_text_font page_text_font_msg">  
              <v-selectprice
                :price="item.price"
                :font-size="14"
                :disable_select="true"
                :country="$store.state.pricetype"
                :show_country="false"
              ></v-selectprice>
            </span>
          </div>
          <!-- 数量 -->
          <div class="order_product__quantity">
            <span>
              <i class="page_text_font">{{$t('account.quantity')}}</i>
            </span>
            <span  class="page_text_font">
                <i  class="page_text_font_msg">{{item.qty}}</i>
            </span>
          </div>
          <!-- 总价 -->
          <div class="order_product__total">
            <span>
              <i class="page_text_font">{{$t('account.total')}}</i>
            </span>
            <span class="page_text_font page_text_font_msg">
                <v-selectprice
                    :price="item.line_total"
                    :font-size="14"
                    :disable_select="true"
                    :country="$store.state.pricetype"
                    :show_country="false"
                ></v-selectprice>
            </span>
          </div>
        </div>
      </div>
      
      <div class="order_total">
        <!-- 折扣前商品总价 -->
        <div class="order_total__subtotal">
          <span>
            <i class="page_text_font">{{$t('account.subtotal')}}</i>
          </span>
          <span>
            <v-selectprice
              :price="order_subtotal"
              :font-size="20"
              :disable_select="true"
              :country="$store.state.pricetype"
              :show_country="false"
            ></v-selectprice>
          </span>
        </div>
        <!-- 折扣 -->
        <div class="order_total__discount " v-if="order.coupons.length || order.discount_record.length || discount_cart > 0">
          <span>
            <i class="page_text_font">{{$t('account.discount')}}</i>
          </span>
          <div>
            <p v-if="order.discount_record.length" class="order_total__discount__label">
              <i 
                v-for="item in order.discount_record" 
                :key="item.order_item_name"
                style="white-space: nowrap;"
                class="iconfont"
              > 
                &#xe718;&nbsp; 
                <i class="page_text_font"> 
                  {{ item.discount_type=='wdr_code_discount' ? item.code : item.description }}
                </i>
              </i>
            </p>
            <p v-else class="order_total__discount__label">
              <i 
                v-for="item in order.coupons" 
                :key="item.order_item_name"
                style="white-space: nowrap;"
                class="iconfont"
              > 
                &#xe718;&nbsp; 
                <i class="page_text_font"> {{item.auto_coupon?item.content:item.order_item_name}}</i>
              </i>
              <i
                v-for="(item, index) in order.extral_coupon" :key="index + item.discount_type"
                style="white-space: nowrap;"
              > 
                <i class="iconfont" v-if="item.discount_value > 0">
                  &#xe718;&nbsp;
                  <span class="page_text_font">{{item.discount_type}}</span>
                </i>
              </i>
            </p>
            <p class="order_total__discount__label">
              <i
                v-for="(item, index) in order.extral_coupon" :key="index + item.discount_type"
                style="white-space: nowrap;"
              > 
                <i class="iconfont" v-if="item.discount_value > 0">
                  &#xe718;&nbsp;
                  <span class="page_text_font">{{item.discount_type}}</span>
                </i>
              </i>
            </p>
            <span class="order_total__discount__price">
              -
              <span>
                <v-selectprice
                  :price="discount_cart"
                  :font-size="16"
                  :disable_select="true"
                  :country="$store.state.pricetype"
                  :show_country="false"
                ></v-selectprice>
                <!-- <i class="page_text_font">$ {{discount_cart.toFixed(2)}}</i> -->
              </span>
            </span>
          </div>
        </div>
        <!-- 运费 -->
        <div class="order_total__fixed" v-if="order.shippings.length">
          <span >
            <i class="page_text_font">{{$t('account.shipping')}} (<i class="secondary_title" style="font-style: normal;" v-html="order.shippings[0].order_item_name"></i>)</i>
          </span>
          <span>
            <v-selectprice
              :price="cost"
              :font-size="20"
              :disable_select="true"
              :country="$store.state.pricetype"
              :show_country="false"
            ></v-selectprice>
            <!-- <i class="page_text_font">$ {{cost-0}}</i> -->
          </span>
        </div>
        <!-- 运费险 -->
        <div class="order_total__fixed" v-if="order.fees.length">
          <span>
            <i class="page_text_font">{{$t('account.shipping_insurance')}}</i>
          </span>
          <span>
            <v-selectprice
              :price="order.fees[0].line_total"
              :font-size="20"
              :disable_select="true"
              :country="$store.state.pricetype"
              :show_country="false"
            ></v-selectprice>
            <!-- <i class="page_text_font">$ {{order.fees[0].line_total}}</i> -->
          </span>
        </div>
        <!-- 订单总价 -->
        <div class="order_total__ordertotal">
          <span>
            <i class="secondary_title">{{$t('account.total')}}</i>
          </span>
          <span>
            <v-selectprice
              :price="order.order_total"
              :font-size="20"
              :disable_select="true"
              :country="$store.state.pricetype"
              :show_country="false"
            ></v-selectprice>
            <!-- <i class="page_text_font">$ {{order.order_total-0}}</i> -->
          </span>
        </div>
      </div>
      <div class="order_address">
        <div class="billing_address_msg">
          <h4 class="title">{{$t('account.billing_address')}}</h4>
          <p class="status">
            <strong>{{$t('account.payment_status')}}:</strong>
            <span class="page_text_font">{{ $t(`account.${order.financial_status}`)}}</span>
          </p>
          <p class="page_text_font">
            {{order.billing_address.first_name}} {{order.billing_address.last_name}}
            <br />
            {{order.billing_address.address_1}} {{order.billing_address.address_2}} {{order.billing_address.city}}
            <br />
            {{order.billing_address.postcode}}
            <span
              v-if="getstate(order.billing_address.state,order.billing_address.country,this.myService)"
              v-html="getstate(order.billing_address.state,order.billing_address.country,this.myService)"
            ></span>
            <span v-else>{{order.billing_address.state}}</span>
            <br />
            {{ getcountry(order.billing_address.country,this.myService)}}
          </p>
        </div>
        <div class="shipping_address_msg">
          <h4 class="title">{{$t('account.shipping_address')}}</h4>
          <p class="status">
            <strong >{{$t('account.fulfillment_status')}}:</strong>
            <span class="page_text_font">{{order.fulfillment_status == 'unfulfilled' ? $t('account.unfulfilled') : order.fulfillment_status == "fulfilled" ? $t('account.fulfilled') : order.fulfillment_status}}</span>
          </p>
          <p class="page_text_font">
            {{order.shipping_address.first_name}} {{order.shipping_address.last_name}}
            <br />

            {{order.shipping_address.address_1}} {{order.shipping_address.address_2}} {{order.shipping_address.city}}
            <br />
            {{order.shipping_address.postcode}}
            <span
              v-if="getstate(order.shipping_address.state,order.shipping_address.country,this.myService)"
              v-html="getstate(order.shipping_address.state,order.shipping_address.country,this.myService)"
            ></span>
            <span v-else>{{order.shipping_address.state}}</span>
            <br />
            {{ getcountry(order.shipping_address.country,this.myService)}}
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-12 order_details">
      <div class="title">
        <h4 class="order_id ">{{$t('account.order')}} #{{order.ID}}</h4>
        <p class="time ">{{order.post_date}}</p>
      </div>
      <table class="table order_table d-none d-md-block">
          <thead >
            <tr >
              <th :style="{width:isMobile?'22%':'auto'}">{{$t('account.product')}}</th>
              <th class='text-uppercase'>{{$t('account.sku')}}</th>
              <th :style="{width:isMobile?'18%':'auto'}">{{$t('account.price')}}</th>
              <th :style="{width:isMobile?'22%':'auto'}">{{$t('account.quantity')}}</th>
              <th :style="{width:isMobile?'18%':'auto'}">{{$t('account.total')}}</th>
            </tr>
          </thead>
          <tbody>
            <!-- 商品 -->
            <tr class="product" v-for="item in items" :key="item.order_item_id">
              <td>
                <a class="page_text_font" :href="item.path||item.public_url">{{item.order_item_name}}</a>
                <div class="page_text_font">{{getProductVariant(item.attrs)}}</div>
                <!-- <div class="note page_text_font" v-if="order.trackno">
                  <div class="page_text_font" style="margin:8px 0"> {{order.track_date}}</div>
                  <div class="page_text_font" style="margin:8px 0">Other #{{order.trackno}}</div>
                </div> -->
              </td>
              <td class="page_text_font ">
                <i>{{item.sku}}</i>
              </td>
              <td class="price secondary_title ">
                <v-selectprice
                  :price="item.price"
                  :font-size="14"
                  :disable_select="true"
                  :country="$store.state.pricetype"
                  :show_country="false"
                ></v-selectprice>
                <!-- <i class="page_text_font">$ {{item.price}}</i> -->
              </td>
              <td class="secondary_title " style="text-align: center;">
                <i>{{item.qty}}</i>
              </td>
              <td class="total secondary_title ">
                <v-selectprice
                  :price="item.line_total"
                  :font-size="14"
                  :disable_select="true"
                  :country="$store.state.pricetype"
                  :show_country="false"
                ></v-selectprice>
                <!-- <i class="page_text_font">$ {{item.line_total}}</i> -->
              </td>
            </tr>
          </tbody>
        </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["order", "cost", "service", "theme_type", "show_currency_selector","currency_style"],
  data() {
    return {
      myService: [],
      discount_cart: 0, //优惠券价格
      items: [],
      order_subtotal: 0, //所有商品折扣前总价
      Shipping_Insurance: 0 //运费险价格
    };
  },
  methods:{
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    getProductVariant(obj){
      return Object.values(obj).join("/")
    }
    
  },
  beforeMount() {
    this.myService = this.service;
  },
  mounted() {
    this.order.coupons.forEach(item => {
      this.discount_cart += item.discount_amount - 0;
    });
    this.order.extral_coupon.forEach(item => {
      this.discount_cart += item.discount_value - 0;
    });
    this.items = this.order.line_items.filter(item => {
      return item.order_item_type === "line_item";
    });

    this.Shipping_Insurance = this.order.fees[0] ? this.order.fees[0].line_total - 0 : 0;

    this.order_subtotal = (this.order.order_total +this.discount_cart -this.cost -this.Shipping_Insurance);
  }
};
</script>
<style scoped lang='scss'>
#app .orderpage{
  padding: 0;
  padding-top: 50px;
  .order_msg{
    padding: 0;
    padding-right: 50px;
    border-right: 1px solid #cccccc;
    .order_products{
      margin-bottom: 30px;
      .order_product{
        background: #F7F7F9;
        padding: 12px 14px;
        margin-bottom: 1px;
        display: flex;
        flex-direction: column;
        font-style:normal;
        &__name,&__sku,&__price,&__quantity,&__total{
          margin: 10px 0px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          &__title{
            white-space: nowrap
          }
          .page_text_font_msg{
            color: #595959;
            font-size: 14px;
            font-family: Roboto;
            font-weight: 400;
            font-style:normal;
          }
          .page_text_font{
            font-size: 14px;
            font-family: Roboto;
            font-weight: 400;
            color: #000000;
            font-style:normal;
          }
          .selectpricewrap{
            &::v-deep .secondary_title{
              color: #595959 !important;
              font-family: Roboto !important;
              font-weight: 400 !important;
              font-style: normal !important;
            }
          }
        }
        &__name{
          span.page_text_font{
            text-align: right;
          }
        }
      }
    }
    .order_total{
      background: #F7F7F9;
      padding: 15px 30px;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      font-style:normal;
      &__subtotal,&__discount,&__fixed,&__ordertotal{
        margin: 10px 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .page_text_font{
          font-size: 20px;
          font-family: Roboto;
          font-weight: 400;
          color: #222A40;
          font-style:normal;
        }
        .selectpricewrap{
          &::v-deep .secondary_title{
            color: #222a40 !important;
            font-family: Roboto !important;
            font-weight: 400 !important;
            font-style: normal !important;
          }
        }
        &__label {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }
      }
      &__discount{
        div{
          display: flex;
          flex-direction: column;
          span{
            margin: 3px 0px;
            .page_text_font{
              font-size: 16px;
              font-family: Roboto;
              font-weight: 400;
              color: #8694A1;
              font-style:normal;
            }
          }
          
        }
        &__price{
          display: flex;
          align-items: center;
          .selectpricewrap{
            &::v-deep .secondary_title{
              color: #8694A1 !important;
              font-family: Roboto !important;
              font-weight: 400 !important;
              font-style: normal !important;
            }
          }
        }
      }
      &__ordertotal{
        .secondary_title{
          font-family: Roboto;
          color: #222A40;
          font-size: 20px;
          font-weight: bold;
          font-style:normal;
        }
        .selectpricewrap{
          &::v-deep .secondary_title{
            color: #222A40 !important;
            font-family: Roboto !important;
            font-weight: bold !important;
            font-style: normal !important;
          }
        }
      }
    }
    .order_address{
      background: #F7F7F9;
      padding: 15px 30px;
      text-align: left;
      .billing_address_msg,.shipping_address_msg{
        margin: 15px 0px;
        .title,.status.page_text_font{
            font-family: Roboto;
            color: #222A40;
        }
        .title{
          font-size: 20px;
          font-weight: 500;
          line-height: 42px;
        }
        .status{
          font-size: 16px;
          font-weight: 500;
          line-height: 42px;
        }
        .page_text_font{
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
  }
  .order_details{
     padding-left: 50px;
     .title{
       display: flex;
       margin-bottom: 45px;
      .order_id{
        font-size: 20px;
        font-family: Roboto;
        font-weight: 400;
        color: #222A40;
      }
      .time{
        font-size: 14px;
        font-family: Roboto;
        font-weight: 300;
        color: #666666;
        line-height: 30px;
        margin-left: 20px;
      }
    }
    .order_table{
      thead {
        background-color: #f7f6fb;
        tr {
          th {
            text-align: left;
            height: 11px;
            font-size: 14px;
            font-family: Roboto;
            font-weight: 500;
            line-height: 42px;
            color: #222A40;
          }
        }
       
      } 
      tbody {
        & > tr {
          border-bottom: 1PX solid #c3c3c3; 
          td {
            word-wrap: normal;
            text-align: left;
            vertical-align: middle;
            height: 14px;
            font-size: 14px;
            font-family: Roboto;
            font-weight: 400;
            color: #222A40;
            line-height: 42px;
            i {
              font-style: normal;
              a {
                text-decoration: underline;
              }
            }
            .selectpricewrap{
              &::v-deep .secondary_title{
                color: #222a40 !important;
                font-family: Roboto !important;
                font-weight: 400 !important;
                font-style: normal !important;
              }
            }
          } 
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .container{
    padding: 0 !important;
  }
  .orderpage{
    padding-top: 20px !important;
    margin: 0;
    .order_msg{
      order: 2;
      padding-left: 15px !important;
      padding-right: 15px !important;
      border: none !important;
      .order_total,.order_address{
        padding: 12px 14px !important;
        .page_text_font{
          font-size: 15px !important;
        }
      }
    }
    .order_details{
      padding: 0 !important;
      order: 1;
      .title{
        margin: 0 15px 25px !important;
      }
      .order_table {
        width: 100%;
        display: table;
        overflow: auto;
        thead{
          tr{
            word-wrap: normal;
            th{
              //width: 20%;
              padding: 17px 8px !important;
              height: 10px !important;
              font-size: 13px !important;
              line-height: 21px !important;
            }
            th:first-child{
              padding-left: 15px !important;
              padding-right: 8px !important;
            }
            th:last-child{
              padding-left: 8px !important;
              padding-right: 15px !important;
            }
          }
        }
        tbody {
          tr {
            td {
              //width: 20%;
              padding:17px 8px !important;
              height: 24px !important;
              font-size: 13px !important;
              line-height: 15px !important;
              &::v-deep{
                .selectpricewrap{
                  .product_price_price{
                    .money{
                      display: flex;
                    }
                  }
                }
              }
            }
            td:first-child{
              padding-left: 15px !important;
              padding-right: 8px !important;
            }
            td:last-child{
              padding-left: 8px !important;
              padding-right: 15px !important;
            }
          }          
          & > tr:last-child {
            border-bottom: 1px solid #c3c3c3 !important; 
          }
        }
      }
    }
  }
}
</style>
